module.exports = __webpack_public_path__ + "app/assets/images/woman7-53bab78b269ee85acd1abfca90d8ba86.jpg";